import Tooltip from "@material-ui/core/Tooltip";
import React from "react";

// TooltipWrapper gets initial MyTooltip props without Tooltip props
// and passes them to children (an input component in this example)
const TooltipWrapper = React.forwardRef(
  ({ children, component: Component = "div", ...props }: any, ref: any) => (
    <Component {...props} ref={ref}>
      {children}
    </Component>
  )
);

// CustomTooltip gets explicit props and props added by SimpleForm
// and passes them together to the Tooltip.
const CustomTooltip = ({ children, component, ...props }: any) => (
  <Tooltip {...props}>
    <TooltipWrapper component={component}>{children}</TooltipWrapper>
  </Tooltip>
);

export default CustomTooltip;
